import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { StrategyAssetsQueryItem } from '../../../../../../../store/customerAssetDetail/types';
import { IDynamicProductSearchItem } from '../../../_dynamic';

import { ProductItemDesktop } from './desktop';
import { ProductItemMobile } from './mobile';
import { ProductItemTablet } from './tablet';

const BaseProductItem: React.FC<IDynamicProductSearchItem<StrategyAssetsQueryItem>> = (props) => {
  return useBreakpointValue({
    base: <ProductItemMobile {...props} />,
    sm: <ProductItemTablet {...props} />,
    lg: <ProductItemDesktop {...props} />,
  });
};

export const ProductItem = React.memo(BaseProductItem);
